module.exports = __webpack_public_path__ + "static/media/services-fullcycle-cycle-bg-1.6bb6cafa.svg";